export default "__VITE_ASSET__ecb0833f__"